<template>
<div>
  <v-dialog persistent v-model="showDialogTotalQueries" max-width="500px">
    <v-card>
      <v-form v-on:submit.prevent="updateUser" v-model="valid" ref="updateUserForm">
        <v-card-title>
          <v-layout wrap>
              <v-flex xs12>
                <h1>Actualizar máximo numero de consultas diarias</h1><br/>
              </v-flex>
              <v-flex xs12 v-if="user">
                <h3 >{{user.name}}</h3>
              </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md style="padding: 2px">
            <v-layout wrap>
               <v-text-field
                  type="number"
                  v-model="totalQueries"
                  min="1"
                  prepend-inner-icon="tag"
                  label="Máxima consulta diaria"
                  :solo="solo"></v-text-field>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog">Cancelar</v-btn>
          <v-btn type="submit" color="success">Guardar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: undefined,
    },
    showDialogTotalQueries: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      totalQueries: 0,
      valid: true,
      solo: true,
    };
  },
  watch: {
    showDialogTotalQueries: {
        deep: true,
        handler(showDialogTotalQueries) {
            if(showDialogTotalQueries){
              this.totalQueries = this.user.totalQueries
            }
        }
    }
  },
  methods: {
    async updateUser() {
      const parameters = {
        totalQueries: this.totalQueries
      };
      try {
        const result = await this.axios.put(`/users/${this.user.id}/totalqueries`, parameters);
        this.user.totalQueries = parameters.totalQueries
        this.$emit('update-user', this.user);
      } catch (error) {
        
        this.closeDialog()
        this.$emit('error', error);
      } finally {
        this.totalQueries = 0
      }
      
    },
    closeDialog() {
      this.$emit('close-dialog-total');
    },
  },
};
</script>
